export const updateMetaTags = (data: {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogType?: string;
  ogImage?: string;
}) => {
  // Update title
  document.title = data.title;

  // Update or create meta tags
  const updateMeta = (name: string, content: string, isProperty = false) => {
    const attribute = isProperty ? 'property' : 'name';
    let element = document.querySelector(`meta[${attribute}="${name}"]`);
    
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attribute, name);
      document.head.appendChild(element);
    }
    
    element.setAttribute('content', content);
  };

  // Basic meta tags
  updateMeta('description', data.description);
  if (data.keywords) {
    updateMeta('keywords', data.keywords);
  }

  // Canonical URL
  const baseUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  const canonicalUrl = data.canonical ? `${baseUrl}${data.canonical}` : baseUrl;
  
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', canonicalUrl);

  // Open Graph tags
  updateMeta('og:type', data.ogType || 'website', true);
  updateMeta('og:url', canonicalUrl, true);
  updateMeta('og:title', data.title, true);
  updateMeta('og:description', data.description, true);
  updateMeta('og:image', data.ogImage || 'https://static.readdy.ai/image/612c2ae47a27268c7e802411c60f5af5/f6fb3f71d1e56eeefab047d5d014f9e4.png', true);

  // Twitter tags
  updateMeta('twitter:card', 'summary_large_image', true);
  updateMeta('twitter:url', canonicalUrl, true);
  updateMeta('twitter:title', data.title, true);
  updateMeta('twitter:description', data.description, true);
  updateMeta('twitter:image', data.ogImage || 'https://static.readdy.ai/image/612c2ae47a27268c7e802411c60f5af5/f6fb3f71d1e56eeefab047d5d014f9e4.png', true);

  // Last modified
  updateMeta('last-modified', new Date().toISOString().split('T')[0]);
};

export const addJsonLd = (data: object) => {
  // Create a unique ID based on the @type
  const schemaType = (data as any)['@type'];
  const scriptId = `jsonld-${schemaType}`;

  // Remove existing JSON-LD of the same type if present
  const existingScript = document.querySelector(`script[id="${scriptId}"]`);
  if (existingScript) {
    existingScript.remove();
  }

  // Add new JSON-LD with unique ID
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = scriptId;
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
};

// New function to clear all JSON-LD schemas
export const clearAllJsonLd = () => {
  const scripts = document.querySelectorAll('script[type="application/ld+json"]');
  scripts.forEach(script => script.remove());
};
